var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 19 11"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.943.802c.25-.23.654-.23.903 0s.249.604 0 .834L3.159 5.04h15.18l.13.012c.29.055.51.293.51.578 0 .325-.287.588-.64.588H3.159l3.688 3.406c.249.23.249.603 0 .833a.676.676 0 0 1-.903 0l-4.778-4.41a.56.56 0 0 1 0-.834z"
  })));
};
export default SvgArrowLeft;